export default __webpack_public_path__ + "static/media/vietgot-screenshot-04.abf2f584.png";